import { Box, Flex, Heading, Icon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { IconType } from "react-icons";
import { FiTool } from "react-icons/fi";
import { usePlaceholderLabel } from "./usePlaceholderLabel";

interface Props {
  titleKey: string;
  descriptionKey: string;
  icon?: IconType;
}

export const PlaceholderPage = ({ titleKey, descriptionKey, icon = FiTool }: Props) => {
  const { t } = useTranslation();
  const label = usePlaceholderLabel();

  return (
    <Box maxW="container.xl" mx="auto">
      <Heading as="h1" size="lg" color="smText" mb="2">
        {label(titleKey)}
      </Heading>
      <Text color="smMuted" mb="8">
        {label(descriptionKey)}
      </Text>
      <Flex
        direction="column"
        align="center"
        justify="center"
        gap="3"
        py="20"
        rounded="xl"
        bg="smBackground"
        border="1px dashed"
        borderColor="smBorder"
        color="smMuted"
      >
        <Icon as={icon} boxSize="32px" />
        <Text fontSize="sm">{t("Coming soon")}</Text>
      </Flex>
    </Box>
  );
};
